import JSONAPISerializer from '@ember-data/serializer/json-api';
import { underscore } from '@ember/string';

import { camelizeKeys } from 'receivable-invoices-js/react/utils/camelize-keys';

export default class ApplicationSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }

  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (payload.data.attributes.sections) {
      payload.data.attributes.sections = camelizeKeys(payload.data.attributes.sections);
    }

    return super.normalizeResponse(store, primaryModelClass, payload, id, requestType);
  }
}
